import type { ChatMessage, ClientChatMessage } from '../../types/ChatMessage';
import type { ChatSession } from '../../types/ChatSession';
import type { ChatStorageManager } from './ChatStorageManager';

/**
 * No-op storage. Sessions/pending-messages/history all round-trip
 * through this without persisting; lets the contexts work end-to-end
 * before an idb-backed implementation lands.
 */
export class DefaultChatStorageManager implements ChatStorageManager {
  constructor(_currentUserId: string | null | undefined) {}

  async getSessions(): Promise<ChatSession[] | null> {
    return null;
  }

  async saveSessions(): Promise<void> {}

  async clearSessions(): Promise<void> {}

  async getPendingMessages(): Promise<ClientChatMessage[]> {
    return [];
  }

  async savePendingMessages(): Promise<void> {}

  async clearPendingMessages(): Promise<void> {}

  async getMessages(): Promise<ChatMessage[]> {
    return [];
  }

  async saveMessages(): Promise<void> {}

  async clearMessages(): Promise<void> {}
}
